import Button from 'components/base/Button';
import AuthSocialButtons from 'components/common/AuthSocialButtons';
import { Col, Form, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const SignUpForm = ({ layout }: { layout: 'simple' | 'card' | 'split' }) => {
  return (
    <>
      <div className="text-center mb-7">
        <h3 className="text-body-highlight">Cadastre-se</h3>
        <p className="text-body-tertiary">Crie sua conta de avaliação grátis</p>
      </div>
      {/* <AuthSocialButtons title="Sign up" /> */}
      {/* <div className="position-relative mt-4">
        <hr className="bg-body-secondary" />
        <div className="divider-content-center">or use email</div>
      </div> */}
      <Form>
        <Form.Group className="mb-3 text-start">
          <Form.Label htmlFor="name">Nome</Form.Label>
          <Form.Control id="name" type="text" placeholder="Nome" />
        </Form.Group>
        <Form.Group className="mb-3 text-start">
          <Form.Label htmlFor="email">E-mail</Form.Label>
          <Form.Control
            id="email"
            type="email"
            placeholder="nome@empresa.com"
          />
        </Form.Group>
        <Row className="g-3 mb-3">
          <Col sm={layout === 'card' ? 12 : 6} lg={6}>
            <Form.Group>
              <Form.Label htmlFor="password">Senha</Form.Label>
              <Form.Control id="password" type="text" placeholder="Senha" />
            </Form.Group>
          </Col>
          <Col sm={layout === 'card' ? 12 : 6} lg={6}>
            <Form.Group>
              <Form.Label htmlFor="confirmPassword">
                Confirme a senha
              </Form.Label>
              <Form.Control
                id="confirmPassword"
                type="text"
                placeholder="Confirme a senha"
              />
            </Form.Group>
          </Col>
        </Row>
        <Form.Check type="checkbox" className="mb-3">
          <Form.Check.Input
            type="checkbox"
            name="termsService"
            id="termsService"
          />
          <Form.Check.Label
            htmlFor="termsService"
            className="fs-9 text-transform-none"
          >
            Eu aceito os <Link to="#!">termos </Link>e{' '}
            <Link to="#!">política de privacidade</Link>
          </Form.Check.Label>
        </Form.Check>
        <Button variant="primary" className="w-100 mb-3">
          Cadastrar
        </Button>
        <div className="text-center">
          <Link
            to={`/pages/authentication/${layout}/sign-in`}
            className="fs-9 fw-bold"
          >
            Entre com uma conta existente
          </Link>
        </div>
      </Form>
    </>
  );
};

export default SignUpForm;
